import { SlideInElementConditionsInformer } from '../../UniversalInformer/JS/ConditionsInformer';
import { SlideInElementContextualInformer } from '../../UniversalInformer/JS/ContextualInformer';
import { SlideInElementFramePositioner } from './Positioner';
import { SlideInElementTracker } from './Tracker';

export default class SlideInElementFrameInitiator {
	public conditionsInformer!: SlideInElementConditionsInformer;
	public contextualInformer!: SlideInElementContextualInformer;
	public positioner!: SlideInElementFramePositioner;
	public tracker!: SlideInElementTracker;

	constructor() {
		if (
			!window.SlideInElementConditionsInformer ||
			!window.SlideInElementContextualInformer ||
			!window.SlideInElementFramePositioner ||
			!window.SlideInElementTracker
		) {
			console.warn(
				'SlideInElementFrameInitiator.trigger: One or more necessary objects not available on window.'
			);
			return;
		}

		this.conditionsInformer = new SlideInElementConditionsInformer(this);
		this.contextualInformer = new SlideInElementContextualInformer(this);
		this.positioner = new SlideInElementFramePositioner(this);
		this.tracker = new SlideInElementTracker(this);
	}

	/**
	 * If the universal criteria are met, trigger the positioner to position the
	 * element.
	 */

	public trigger(element: HTMLElement): void {
		if (!element || !element.dataset) {
			console.warn('SlideInElementFrameInitiator.trigger: element not of expected format.', element);
			return;
		}

		if (!this.conditionsInformer || !this.contextualInformer || !this.positioner || !this.tracker) {
			return;
		}

		if (!this.conditionsInformer.areConditionsMet()) {
			// The universal conditions to show a slide-in element are not met, so stop here.
			return;
		}

		this.positioner.positionElement(element);
	}
}

window['SlideInElementFrameInitiator'] = SlideInElementFrameInitiator;
